import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Box, Typography } from "@mui/material";
import styled from "@emotion/styled";

const FormField = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

const HalfWidthField = styled(FormField)(({ theme }) => ({
    width: "50%",
    [theme.breakpoints.down("sm")]: {
        width: "100%",
    },
}));

const HintText = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
}));

const SLOT_OPTIONS = Array.from({ length: 10 }, (_, i) => i + 1);

const StepAssign = ({ form, onChange }) => {
    return (
        <Box>
            <HintText variant="body2">
                Assign an employee slot as the responsible person for this template item. When the template is executed,
                you'll map each slot to a real employee. Leave as None if no responsible assignment is needed.
            </HintText>
            <HalfWidthField>
                <FormControl fullWidth>
                    <InputLabel>Responsible Employee Slot</InputLabel>
                    <Select
                        name="responsibleSlot"
                        value={form.responsibleSlot ?? 0}
                        onChange={onChange}
                        label="Responsible Employee Slot"
                    >
                        <MenuItem value={0}>None</MenuItem>
                        {SLOT_OPTIONS.map((n) => (
                            <MenuItem key={n} value={n}>
                                Employee {n}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </HalfWidthField>
        </Box>
    );
};

export default StepAssign;
